import SupportLink from './SupportLink'

export default SupportLink
